import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class IconRegistrationService {

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  registerIcons(): void {
    // Register helping-hand SVG icon in the default namespace
    const helpingHandUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/home/Icons/helping-hand.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'helping-hand', helpingHandUrl);

    // Register heart-handshake icon for How It Works step 1
    const heartHandshakeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/home/Icons/heart-handshake.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'heart-handshake', heartHandshakeUrl);

    // Register contribute icon (Vector.svg) for How It Works step 2
    const contributeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/home/Icons/Vector.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'contribute-confidently', contributeUrl);

    // Register shield-check icon for How It Works step 3
    const shieldCheckUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/home/Icons/shield-check.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'shield-check', shieldCheckUrl);

    // Register close-dialog icon for dialog close button
    const closeDialogUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/close-dialog.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'close-dialog', closeDialogUrl);

    // Register close-dialog-mobile icon for mobile back button
    const closeDialogMobileUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/close-dialog-mobile.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'close-dialog-mobile', closeDialogMobileUrl);
    // Register arrow navigation icons
    const arrowLeftUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/home/Icons/ooui_next-left.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'arrow-left', arrowLeftUrl);

    const arrowRightUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/home/Icons/ooui_next-right.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'arrow-right', arrowRightUrl);

    const suitecaseLine = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/home/Icons/mingcute_suitcase-line.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'suitecase-line', suitecaseLine);

    // Register settings icons
    const settingsInfoUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/settings/info.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'settings-info', settingsInfoUrl);

    const settingsSecurityUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/settings/security.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'settings-security', settingsSecurityUrl);

    const settingsFavoritesUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/settings/favorites.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'settings-favorites', settingsFavoritesUrl);

    const settingsCharitiesUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/settings/charities.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'settings-charities', settingsCharitiesUrl);

    const settingsProjectsUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/settings/projects.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'settings-projects', settingsProjectsUrl);

    const settingsPortfoliosUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/settings/portfolio.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'settings-portfolios', settingsPortfoliosUrl);

    const settingsUsersUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/settings/users.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'settings-users', settingsUsersUrl);

    const settingsChampionsUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/settings/champions.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'settings-champions', settingsChampionsUrl);

    const settingsGlobalSettingsUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/settings/settings.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'settings-global-settings', settingsGlobalSettingsUrl);

    const settingsPromotionalToolsUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/settings/promotional-tools.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'settings-promotional-tools', settingsPromotionalToolsUrl);

    const settingsFundSettingsUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/settings/fund-settings.svg');
    this.matIconRegistry.addSvgIconInNamespace('', 'settings-fund-settings', settingsFundSettingsUrl);
  }
}
